<div class="wrapper__headerComponent container my-5">
  <div *ngIf="encuesta">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12">
          <h2 class="text-center h3-tipografia-govco mb-0">
            {{ encuesta.Descripcion }}
          </h2>
        </div>
      </div>
      <div class="row description-message">
        <p>{{ encuesta.Mensaje_Entrada }}</p>
      </div>
      <div class="row">
        <p>Las preguntas con (*) son obligatorias.</p>
      </div>
    </div>
    <div class="row align-items-center">
      <form [formGroup]="encuestaForm" (ngSubmit)="onSubmit()">
        <div class="formulario-encuesta">
          <div
            *ngFor="let pregunta of preguntas; let i = index"
            class="pregunta">
            <label class="pregunta-titulo">{{ capitalizarFrase(pregunta.Descripcion) }}</label>
            <div *ngIf="pregunta.Tipo_Campo === 'radiobutton'" class="opciones">
              <div
                class="opcion"
                *ngFor="let opcion of pregunta.Opcion_Respuesta_Pregunta">
                <label>
                  <input
                    type="radio"
                    [value]="opcion"
                    [formControlName]="'pregunta' + i" />
                  {{ opcion.Descripcion }}
                </label>
              </div>
            </div>

            <div *ngIf="pregunta.Tipo_Campo === 'text'" class="campo-texto">
              <input type="text" [formControlName]="'pregunta' + i" />
            </div>
          </div>
        </div>
        <button type="submit"
                class="btn-govco fill-btn-govco mt-3"
                style="width: 165px; height: 42px"
                [disabled]="!encuestaForm.valid"
                aria-label="Enviar encuesta">
          Enviar
        </button>
      </form>
    </div>
  </div>
  <div *ngIf="encuesta === null" class="no-data-found">
    <div class="content">
      <p>Lo sentimos, la encuesta no fue encontrada o ya fue diligenciada</p>
      <button class="go-home" (click)="goHome()"
      aria-label="Ir al inicio">Ir al inicio</button>
    </div>
  </div>
</div>
